<template>
    <div class="transaction-finished">
        <div @click="leave" class="ready">
            <div class="logo">
                <img src="@/assets/img/logos/vod_logo.svg" />
            </div>
            <div class="title">{{ $t('BUTTON_CONTINUE_LONG') }}</div>
            <div>
                <ActionButton
                    :label="$t('BUTTON_CONTINUE_LONG')"
                    @click="leave"
                    color="apple"
                ></ActionButton>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            mobileDevice: false,
            initLoading: true,
            redirectType: ''
        }
    },
    methods: {
        leave() {
            if (this.redirectType == 'marketplace_bills') {
                this.$router.replace('/vod')
                window.open('https://vod.akademialivekid.pl')
            } else {
                if (this.mobileDevice == true) {
                    window.location.href = 'livekid://payment/finished'
                } else {
                    this.$router.replace('/')
                }
            }
        },
        checkTransaction() {
            const transaction = this.$route.query.OrderID
            this.$axios
                .get(
                    `${process.env.VUE_APP_API_URL.replace(
                        '{region}',
                        'pl'
                    )}v1/payments/transactions/${transaction}/type`
                )
                .then(({ data }) => {
                    this.redirectType = data
                })
                .catch(error => {
                    console.log(error)
                })
                .then(() => {
                    this.initLoading = false
                })
        },
        checkDevice() {
            if (
                navigator.userAgent.match(/Android/i) ||
                navigator.userAgent.match(/webOS/i) ||
                navigator.userAgent.match(/iPhone/i) ||
                navigator.userAgent.match(/iPad/i) ||
                navigator.userAgent.match(/iPod/i) ||
                navigator.userAgent.match(/BlackBerry/i) ||
                navigator.userAgent.match(/Windows Phone/i)
            ) {
                this.mobileDevice = true
            } else {
                this.mobileDevice = false
            }
        }
    },
    mounted() {
        this.checkDevice()
        this.checkTransaction()
    }
}
</script>
<style lang="scss" scoped>
.ready {
    color: $input;
    position: fixed;
    border-radius: $modal-radius;
    width: 400px;
    height: 250px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    text-align: center;
    padding: 20px 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.title {
    font-size: 25px;
    font-family: $input-family;
}
.transaction-finished {
    height: 100%;
    width: 100%;
}
.logo {
    max-width: 100%;
    margin: 20px auto;
    text-align: center;
}
.logo img {
    width: 180px;
}
@media (max-width: 400px) {
    .ready {
        width: 80%;
    }
    .title {
        font-size: 22px;
    }
}
</style>
